export const contentTableConfig = {
  title: '用户金币列表',
  propList: [
    {
      prop: 'loginName',
      label: '账号',
      minWidth: '80'
    },
    {
      prop: 'nickName',
      label: '昵称',
      minWidth: '80'
    },
    {
      prop: 'point',
      label: '金币数量',
      minWidth: '120'
    },
    {
      prop: 'opr',
      label: '操作',
      minWidth: '120',
      slotName: 'opr'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
